module.exports = __webpack_public_path__ + "static/media/loader.6a19979e.svg";